import NavLink from "./NavLink";
import { cn } from "@/lib/utils";

export default function FooterNavLink({ href, external, children, className }) {
  if (external) {
    return (
      <a
        href={href}
        className={cn("text-sm text-neutral-300 transition-colors hover:text-white", className)}
      >
        {children}
      </a>
    );
  }
  return (
    <NavLink
      href={href}
      className={cn("text-sm text-neutral-300 transition-colors hover:text-white", className)}
    >
      {children}
    </NavLink>
  );
}
